<template>
    <div>
        <div class="vetlife-header">
            <p>We are honored to serve our Veterans</p>
        </div>
    </div>
    <div class="vetlife-body">
        <div class="vetlife-text">
            <div class="video-container">
                <iframe src="https://player.vimeo.com/video/889232764?badge=0&autopause=0&player_id=0&app_id=58479"
                    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
                    title="Vimeo Video"></iframe>
            </div>
            <p>
                As a lender authorized to provide the VA home financing guaranteed by the Department of Veterans
                Affairs, <span class="bold">we’re privileged to serve those we believe are most deserving of
                    homeownership</span>.
                You can expect clear answers and thoughtful guidance each step of the way, and we promise your
                financing experience will be simple and transparent. Homeownership is the cornerstone of financial
                security, and you deserve nothing less.
            </p>
            <p>
                <span class="bold">To learn more, please provide your contact information, or give us a call at</span>
                <a href="tel:800-201-5626" aria-label="Contact Gold Star Mortgage Financial Group at 800-201-LOAN.">
                    800-201-LOAN
                </a>
            </p>
        </div>
        <div class="vetlife-form">
            <img src="https://gslogo.s3.amazonaws.com/2024GSlogo.png">
            <formcontent @submit="handleSubmit" />
        </div>
    </div>
    <FooterComp></FooterComp>
</template>

<script>
import FooterComp from '@/components/Footer_Comp.vue';
import FormContent from '@/components/FormContent.vue';
import apiService from '@/api/api.service';

export default {
    name: "VetLife",
    components: {
        'formcontent': FormContent,
        FooterComp
    },
    methods: {
        handleSubmit(dataItem) {
            apiService.post('api/LOWebsites/SubmitVetLifeForm', dataItem)

                .then(() => {
                    alert("Form submitted and email sent successfully!");
                })
                .catch((error) => {
                    console.error("Error submitting form", error);
                    alert("There was a problem submitting the form.");
                });
        }
    }
}
</script>

<style>
.vetlife-header {
    height: 400px;
    background-image:
        linear-gradient(to top, rgba(245, 246, 252, 0.12), rgb(24, 24, 24)),
        url(https://www.radiantmortgage.com/wyoming/wp-content/uploads/sites/21/2024/12/resources-banner.webp);
    background-position: center center;
    background-size: cover;
    text-align: center;

    p {
        color: white;
        font-size: 54px;
        padding-top: 150px;
    }
}

.vetlife-body {
    gap: 100px;
    display: flex;
    padding: 50px 0px;
    justify-items: center;
    justify-self: center;
    width: 80vw;
    max-width: 1800px;

    p {
        padding-bottom: 50px;
    }

    a {
        color: blue;
        font-weight: bold;
        text-decoration: underline;
    }
}


.k-form-fieldset {
    max-width: 800px;
}

.vetlife-text {
    width: 50%;
}

.vetlife-form {
    margin-top: -40px;
    border-radius: 10px;
    border-color: black;
    border: solid;
    border-width: 1px;
    padding: 50px;
    width: 50%;

    img {
        display: block;
        margin: 0 auto 30px auto;
        width: 15vw;
    }
}

.k-form-md {
    max-width: 3000px !important;
}

.video-container {
    position: relative;
    width: 100%;
    max-width: 640px;
    aspect-ratio: 16 / 9;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
}

.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: none;
}


video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

@media (max-width: 1120px) {
    .vetlife-body {
        display: block;
    }

    .vetlife-text {
        width: 80%;
    }

    .vetlife-form {
        width: 80%;
    }
}
</style>